import React, { useEffect, useRef, useState } from 'react'
import { verifyVoucherPassCode } from '../../apiConnections/bubbleApi';
import OtpInput from 'react-otp-input';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { axios_updateVoucherStatus } from '../../apiConnections/voucherApi';
import { toast } from 'react-toastify';
import ErrorPage from '../../pages/error-page/ErrorPage';

export default function BallsGamePasscode(props) {


    const location = useLocation();
    // const searchParams = new URLSearchParams(location.search);
    const { voucher_id } = useParams();

    const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

    const gameData = useSelector((state) => state?.game?.gameData)

    const [otp, setOtp] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const [errorData, setErrorData] = useState(null);

    const inputChangeAudio = new Audio('../sound/click-for-game-menu-131903.mp3');
    const gameStartAudio = new Audio('../sound/game-start-6104.mp3');
    const errorAudio = new Audio('../sound/error-2-36058.mp3')


    const playGameHandler = () => {

        gameStartAudio.play()
        setIsLoading(true)

        if (otp === "") {
            setTimeout(() => {
                toast.dismiss();
                toast.error("Please Enter Passcode!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                });

                errorAudio.play()
                setIsLoading(false)
            }, 2000);
        } else {
            let passCodeReq = {
                voucher_id: voucher_id,
                passcode: otp
            }
            verifyVoucherPassCode(passCodeReq, verifyVoucherPassCodeCallback)
        }
    }

    const verifyVoucherPassCodeCallback = (response) => {
        setIsLoading(false)
        if (response.status === 200) {
            if (response.data.error) { //need to remove ! when production
                if (response.data.error === "invalid_credentials") {
                    toast.dismiss();
                    toast.error(response.data.error_message ?? "Oops! Something went wrong.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                    });
                } else {
                    setErrorData({
                        title: response.data.error_title || 'Error',
                        message: response.data.error_message || 'An unexpected error occurred.',
                        error_redirect_url: response.data.error_redirect_url || null,
                    });
                }
            } else {

                //update step status
                const updateStatusReq = {
                    voucher_id: voucher_id,
                    status: 2 // verfiy password
                }
                axios_updateVoucherStatus(updateStatusReq)

                props.setCurrentStep("game")

                // if (document.documentElement.requestFullscreen) {
                //     document.documentElement.requestFullscreen()
                //         .catch(error => console.error(error));
                // }
                // if (document.documentElement.webkitRequestFullscreen) {
                //     document.documentElement.webkitRequestFullscreen()
                //         .catch(error => console.error(error));
                // }
                // if (document.documentElement.mozRequestFullScreen) {
                //     document.documentElement.mozRequestFullScreen()
                //         .catch(error => console.error(error));
                // }
                // if (document.documentElement.msRequestFullscreen) {
                //     document.documentElement.msRequestFullscreen()
                //         .catch(error => console.error(error));
                // }


            }
        }
        setIsLoading(false)
    };

    if (errorData) {
        return <ErrorPage title={errorData.title} message={errorData.message} errorRedirectUrl={errorData?.error_redirect_url} />;
    }


    return (
        <>
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ minHeight: '100vh' }}>
                <div>

                    <div className='pt-3'>
                        <img src={gameData?.company?.company_logo} width={150} className='img-fluid py-2' alt="company" />
                    </div>
                    <div className='pt-3'>
                        <img src={gameData?.game?.game_data?.game_logo} width={210} className='img-fluid py-2' alt="company" />
                    </div>

                    <div className='text-42526a pt-3'>
                        <h1 className='fw-bolder py-3'>{gameData?.game?.title}</h1>
                        <h4>ENTER YOUR PASSCODE</h4>
                        <p>Enter 4 digit passcode from the SMS</p>
                    </div>

                    <div>

                        <div className='container mt-4'>

                            <div className='d-flex justify-content-center'>
                                <div>
                                    <OtpInput
                                        inputType='tel'
                                        value={otp}
                                        onChange={(e) => { setOtp(e); inputChangeAudio.play() }}
                                        numInputs={4}
                                        renderSeparator={<span>-</span>}
                                        renderInput={(props) => <input {...props} style={{ width: '50px', height: '50px', textAlign: 'center', fontSize: '1.75rem' }} />}
                                        shouldAutoFocus={true}
                                    />
                                </div>
                            </div>


                            <div className='mt-5'>
                                <button className='secondary-button' onMouseDown={() => playGameHandler()} disabled={isLoading}>
                                    {isLoading ?
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        :
                                        "Enter"
                                    }
                                </button>
                            </div>


                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
